<template>
  <div class="sched-app-timezone-selector">
    <label :class="channelColorCSS">Select Timezone</label>
    <v-select :options="zones" :value="selected" @input="changed" :clearable="false" />
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  computed: {
    zones () {
      return moment.tz.names()
    },
    selected () {
      return this.$store.state.timezone
    },
    channelColorCSS () {
      return `sched-app-${this.$store.state.channel.value}-color`
    }
  },
  methods: {
    changed (timezone) {
      this.$store.dispatch('fetchData', { timezone })
    }
  }
}
</script>

<style>
.sched-app-timezone-selector {
  margin: 20px 0;
}
.sched-app-timezone-selector label {
  font-weight: 700;
}
.sched-app-timezone-selector .dropdown {
  min-width: 260px;
}
</style>
